import dayjs from 'util/dayjs';

// La franja de una a demanda: "10:00 a 13:00". Sin fin, solo la hora de inicio.
// Con utcOffset ("-03:00") se muestra en la hora del cliente, no en la del
// navegador.
export const collectionWindow = (
  start: string,
  end?: string | null,
  dateFormat?: string,
  utcOffset?: string | null,
) => {
  const at = (value: string) =>
    utcOffset ? dayjs(value).utcOffset(utcOffset) : dayjs(value);
  const from = at(start);
  const prefix = dateFormat ? `${from.format(dateFormat)} ` : '';
  if (!end) return `${prefix}${from.format('HH:mm')}`;
  return `${prefix}${from.format('HH:mm')} a ${at(end).format('HH:mm')}`;
};
